import { store } from "store/store";
import { Meme } from "../types";

export function getMeme(): Meme {
    const meme = store.getState().memeGenerator.meme;
    if (!meme) throw new Error("Meme not found");
    return meme;
}
